import { useParams } from "react-router-dom";

const ConfirmacionScreen = () => {
  const { lang } = useParams();

  const mensaje = lang === "en" ? "Your data has been successfully submitted." : "Tus datos se han enviado correctamente.";
  const mensajeCerrar = lang === "en" ? "You may now close this window." : "Ya puedes cerrar esta ventana.";

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light text-center p-4">
      <img
        src="https://were.ppf.com.hn/assets/Logo_PPF_PrimarioH.png"
        alt="Logo PPF"
        className="mb-4 animate__animated animate__fadeIn"
        style={{ maxWidth: '400px', filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.2))' }}
      />
      <h1 className="mb-3 text-primary animate__animated animate__fadeInDown">
        {mensaje}
      </h1>
      <h5 className="text-secondary animate__animated animate__fadeInUp">
        {mensajeCerrar}
      </h5>
    </div>
  );
};

export default ConfirmacionScreen;

